import { jsx as o, jsxs as f } from "@emotion/react/jsx-runtime";
import { StyledHeaderCell as S, StyledText as x, StyledTooltipContainer as u, StyledIconContainer as C, ArrowUpIcon as h, ArrowDownIcon as v } from "./HeaderCell.styled.js";
import { Icon as w } from "../../../Icon/index.js";
import { Tooltip as g } from "../../../Tooltip/index.js";
import { FontAwesomeIconsPartooUsed as t, IconPrefix as d } from "../../../../types/components/icon.js";
const D = ({
  order: n
}) => /* @__PURE__ */ f(C, { children: [
  /* @__PURE__ */ o(h, { icon: [t.faCaretUp, d.SOLID], iconSize: "10px", color: n === "ascending" ? "default" : "secondary" }),
  /* @__PURE__ */ o(v, { icon: [t.faCaretDown, d.SOLID], iconSize: "10px", color: n === "descending" ? "default" : "secondary" })
] }), T = ({
  children: n,
  className: p,
  isOrdered: r,
  onOrder: c,
  orderDirection: l,
  width: m,
  maxWidth: y,
  minWidth: I,
  info: s
}) => {
  let e;
  r && l === "asc" ? e = "ascending" : r && l === "desc" && (e = "descending");
  const i = c ? () => c(e === "ascending" ? "desc" : "asc") : void 0;
  return /* @__PURE__ */ o(S, { className: p, onClick: i, "data-order": c ? "button columnheader" : void 0, onKeyDown: i ? (a) => {
    (a.key === " " || a.key === "Enter") && (i(), a.key === " " && a.preventDefault());
  } : void 0, scope: "col", width: m, maxWidth: y, minWidth: I, tabIndex: i ? 0 : -1, "aria-sort": e, children: /* @__PURE__ */ f(x, { as: "div", variant: "sort", color: e !== void 0 ? "default" : "secondary", children: [
    n,
    s ? /* @__PURE__ */ o(u, { children: /* @__PURE__ */ o(g, { text: s, children: /* @__PURE__ */ o(w, { icon: [t.faCircleInfo, d.SOLID], iconSize: "12px", color: "secondary" }) }) }) : null,
    l !== void 0 && r !== void 0 ? /* @__PURE__ */ o(D, { "aria-disabled": !c, order: e }) : null
  ] }) });
};
export {
  T as HeaderCell
};
